// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1CpWh","label":"SetPasswdForm_label__3WbPj"};